module.exports = __webpack_public_path__ + "img/card_conchali_background.54ce9442.png";